import { apiRequest } from './apiHelpers';

export const fetchAllUsers = async () => {
  const data = await apiRequest('/api/admin/users');
  return Array.isArray(data) ? data : [];
};

export const fetchRoles = async () => {
  const data = await apiRequest('/api/admin/roles');
  return Array.isArray(data) ? data : data?.roles || [];
};

export const createUser = (formData) =>
  apiRequest('/api/admin/newuser', {
    method: 'POST',
    body: JSON.stringify(formData),
  });

export const assignRole = (keycloakUserId, roleId) =>
  apiRequest(
    `/api/admin/users/${encodeURIComponent(keycloakUserId)}/roles/${encodeURIComponent(roleId)}`,
    { method: 'POST' },
  );

export const unassignRole = (keycloakUserId, roleId) =>
  apiRequest(
    `/api/admin/users/${encodeURIComponent(keycloakUserId)}/roles/${encodeURIComponent(roleId)}`,
    { method: 'DELETE' },
  );
